import saveAs from 'file-saver'
// console.log(saveAs)
window.saveAs = saveAs;
export default saveAs;